// extracted by mini-css-extract-plugin
export default {"ticketHint":"leave-details_ticketHint__qJqbE"};